// composables/useTime.ts
import { ref, onMounted, onUnmounted } from "vue";

export function useTime(zone: "WIB" | "WITA" | "WIT" = "WIB") {
  const time = ref("");
  const date = ref("");

  const zoneMap: Record<string, string> = {
    WIB: "Asia/Jakarta",
    WITA: "Asia/Makassar",
    WIT: "Asia/Jayapura",
  };

  const timeZone = zoneMap[zone];

  const updateTime = () => {
    const now = new Date();

    // Format tanggal: Sabtu 10 Juni 2023
    const dateFormatter = new Intl.DateTimeFormat("id-ID", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
      timeZone,
    });
    date.value = dateFormatter.format(now);

    // Format waktu: 16.19
    const timeFormatter = new Intl.DateTimeFormat("id-ID", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone,
    });

    // Intl.DateTimeFormat tidak langsung memberikan waktu terpisah, jadi kita parsing string
    time.value = timeFormatter.format(now).replace(".", ":");
  };

  function formatDate(
    dateString: string,
    mode: Intl.DateTimeFormatOptions["month"] = "short",
  ) {
    const date = new Date(dateString);

    const day = date.getDate();
    const month = date.toLocaleString("id-ID", { month: mode }); // Jan, Feb, Mar
    const year = date.getFullYear();

    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    if (mode === "long") {
      return `${day} ${month} ${year} ${hours}:${minutes}`;
    } else {
      return `${day} ${month} ${year}, ${hours}.${minutes}`;
    }
  }

  function formatDateDMY(
    dateString: string | Date,
    mode: Intl.DateTimeFormatOptions["month"] = "short",
  ) {
    const date = new Date(dateString);

    const day = date.getDate();
    const month = date.toLocaleString("id-ID", { month: mode }); // Jan, Feb, Mar
    const year = date.getFullYear();

    if (mode === "2-digit") {
      return `${day}-${month}-${year}`;
    } else {
      return `${day} ${month} ${year}`;
    }
  }

  let interval: NodeJS.Timeout;

  onMounted(() => {
    updateTime();
    interval = setInterval(updateTime, 1000);
  });

  onUnmounted(() => {
    clearInterval(interval);
  });

  return {
    time,
    date,
    formatDate,
    formatDateDMY,
  };
}
